module.exports = __webpack_public_path__ + "img/tax-rate-high.e0b85e5b.svg";